import { Footer as KernelFooter } from "@kelp-dao/kernel-design-system";
import { FOOTER_CONFIG } from "./FooterConfig";

export const FooterV2 = () => {
  return (
    <KernelFooter
      sections={FOOTER_CONFIG.sections}
      socialIcons={FOOTER_CONFIG.socialIcons}
      policies={FOOTER_CONFIG.policies}
      copyright={FOOTER_CONFIG.copyright}
    />
  );
};
